import { create } from 'zustand';

/**
 * @typedef {Object} ChatPanelStore
 * @property {boolean} showChatPanel - Whether the ChatPanel is visible
 * @property {string | null} chatSessionId - The chat session ID
 *
 * @property {(showChatPanel: boolean) => void} setShowChatPanel - Sets the showChatPanel state
 * @property {(chatSessionId: string) => void} setChatSessionId - Sets the chatSessionId state
 */

const initState = {
  showChatPanel: false,
  chatSessionId: null,
};

/**
 * Store for the AddressPanel component
 * @type {import('zustand').UseBoundStore<import('zustand').StoreApi<ChatPanelStore>>}
 * */
const useChatPanelStore = create((set) => ({
  ...initState,

  setShowChatPanel: (showChatPanel) => set(() => ({ showChatPanel })),
  setChatSessionId: (chatSessionId) => set(() => ({ chatSessionId })),
}));

export default useChatPanelStore;
